import type { IconData } from '@stacksjs/iconify-core'

export const gn1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"red\" d=\"M0 0h170.7v512H0z\"/><path fill=\"#ff0\" d=\"M170.7 0h170.6v512H170.7z\"/><path fill=\"#090\" d=\"M341.3 0H512v512H341.3z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default gn1x1
